// @flow
/* eslint react/no-this-in-sfc:0 */
import React, { type ElementRef, Fragment } from 'react';
import i18n from 'app/common/lib/i18n';
import NuxPickerInterests from 'app/common/react/components/growth/activation/NuxPicker/NuxPickerInterests';
import NuxTopicSearchBar from 'app/common/react/components/growth/activation/NuxTopicSearchBar/NuxTopicSearchBar';
import once from 'lodash/once';
import RenuxCategoryPicker from 'app/common/react/components/growth/activation/Renux/RenuxCategoryPicker';
import storage from 'app/common/lib/Storage';
import { Experiment } from 'app/common/react/components/experiments';
import {
  type InterestObj,
  type CategoryObj,
} from 'app/common/react/components/growth/activation/NuxConst/NuxConst';
import { Box, Spinner } from 'gestalt';

type OwnProps = {|
  categorized?: boolean,
  categoryProps: {
    categories?: Array<CategoryObj>,
    handleInterestClickFn?: (InterestObj) => () => void,
  },
  disableScroll: boolean,
  handleBottomScroll: (isBottom: boolean) => void,
  handleInterestClickFn: (InterestObj) => () => void,
  interests: Array<InterestObj>,
  selectedInterests: Array<InterestObj>,
  showTableOfContents?: boolean,
  interestFlipMessages: { [key: string]: string },
  interestsToFlip: Set<string>,
  isRenux: boolean,
|};

type Props = {|
  ...OwnProps,
|};

type State = {|
  showSearch: boolean,
|};

const logScrollEvent = once(() => {
  storage.localStorage.setItem(PCONST.LOCALSTORAGE_SIGNUP_INTERESTS_PICKER_SCROLL_DOWN, true);
});

class NuxPickerInterestsGrid extends React.PureComponent<Props, State> {
  state = {
    showSearch: true, // TODO(joyj) implement in a later PR
  };

  gridContainer: ElementRef<any>;

  handleScroll = () => {
    const isBottom =
      this.gridContainer.scrollTop ===
      this.gridContainer.scrollHeight - this.gridContainer.offsetHeight;
    logScrollEvent();
    this.props.handleBottomScroll(isBottom);
    if (isBottom) {
      this.setState({ showSearch: true });
    }
  };

  render() {
    const {
      categorized,
      categoryProps,
      disableScroll,
      handleInterestClickFn,
      interests,
      isRenux,
      showTableOfContents,
      interestFlipMessages,
      interestsToFlip,
      selectedInterests,
    } = this.props;
    const { showSearch } = this.state;
    let picker = (
      <NuxPickerInterests
        gridContainerRef={this.gridContainer}
        handleInterestClickFn={handleInterestClickFn}
        interests={interests}
        isRenux={isRenux}
        showTableOfContents={showTableOfContents}
        interestFlipMessages={interestFlipMessages}
        interestsToFlip={interestsToFlip}
      />
    );

    if (categorized && categoryProps.categories) {
      picker = <RenuxCategoryPicker {...this.props} {...categoryProps} />;
    }

    return (
      <Box
        dangerouslySetInlineStyle={{ __style: { paddingBottom: !categorized && '40px' } }}
        height={showTableOfContents ? '280px' : '368px'}
        flex="grow"
        overflow={disableScroll ? 'visible' : 'scrollY'}
        width="800px"
      >
        <div
          onScroll={this.handleScroll}
          ref={(ref) => {
            this.gridContainer = ref;
          }}
        >
          {interests.length > 0 ? (
            <Fragment>
              {picker}
              {showSearch && (
                <Experiment name="web_renux_topic_search" isEligible={isRenux}>
                  {({ anyEnabled: renuxEnabled }) => (
                    <Experiment name="web_nux_topic_search" isEligible={!isRenux}>
                      {({ anyEnabled: nuxEnabled }) =>
                        (nuxEnabled || renuxEnabled) && (
                          <Box width="100%" paddingY={7}>
                            <NuxTopicSearchBar
                              handleInterestClickFn={handleInterestClickFn}
                              interestFlipMessages={interestFlipMessages}
                              interestsToFlip={interestsToFlip}
                              isRenux={isRenux}
                              selectedInterests={selectedInterests}
                              suggestedSearchQuery={interests[0].name}
                            />
                          </Box>
                        )
                      }
                    </Experiment>
                  )}
                </Experiment>
              )}
            </Fragment>
          ) : (
            <Spinner accessibilityLabel={i18n._('Loading default interests')} show />
          )}
        </div>
      </Box>
    );
  }
}

export default NuxPickerInterestsGrid;
